// EN
export const availabilityPrices = {
  header: {
    title: "Disponibilidade e Tarifas",
  },
  common: {
    today: "Hoje",
    cancel: "Cancelar",
    save: "Salvar",
    saving: "Salvando…",
  },
  pricelabs: {
    title: "Os preços estão sendo gerenciados pelo PriceLabs",
    text: "As tarifas são atualizadas automaticamente e não podem ser editadas manualmente.",
  },
  topbar: {
    calendar: "Calendário",
    bulkEdit: "Edição em massa",
    configTitle: "Configurações do calendário",
    syncSection: "Sincronização",
    resyncOta: "Ressincronizar com a OTA",
    resyncOtaDesc: "Reenvia a disponibilidade e as tarifas para o canal.",
  },
  empty: {
    noHotelTitle: "Nenhum anúncio do tipo hotel",
    noHotelDesc:
      "Crie um anúncio de <strong>Hotel</strong> ou <strong>Camping</strong> para começar a gerenciar a disponibilidade e as tarifas.",
    goToListings: "Ir para os anúncios",
    noRoomsTitle: "{name} não tem quartos",
    noRoomsDesc:
      "Este anúncio ainda não tem nenhum quarto cadastrado. Adicione unidades pelos detalhes do anúncio para gerenciar a disponibilidade e as tarifas.",
    configureListing: "Configurar anúncio",
  },
  summary: {
    roomState: "Status do quarto",
    roomsForSale: "Quartos à venda",
    netBooked: "Reservas líquidas",
  },
  state: {
    available: "Disponível",
    closed: "Fechado",
    soldOut: "Esgotado",
    pastLabel: "N/D",
  },
  calendar: {
    // Pluralization (vue-i18n v8 pipes) — choiceIndex = number of rooms / nights
    roomsCount: "{count} quarto | {count} quartos",
    minStayTooltip: "Estadia mínima: {count} noite | Estadia mínima: {count} noites",
  },
  offBadge: "DESLIGADA",
  offTooltip: "Venda desligada: esta tarifa não é oferecida em nenhum canal. As outras tarifas do quarto continuam à venda.",
  rateMenu: {
    open: "Opções da tarifa",
    minStay: "Estadia mínima por datas",
    priceLabsMinStay: "Esta tarifa é gerida pelo PriceLabs: a estadia mínima é definida por ele.",
    stopSelling: "Desligar a venda desta tarifa",
    stopping: "Desligando a venda…",
    resuming: "Reativando a venda…",
    resumeSelling: "Reativar a venda desta tarifa",
    derivedPriceHint: "O preço de uma tarifa derivada vem da principal",
    mainKeepsDerived: "As suas tarifas derivadas continuarão à venda",
    mainNotYet: "Desligar uma tarifa principal ainda não está disponível",
  },
  derived: {
    badge: "D",
    tooltip: "Tarifa derivada de: {parent}{rule}",
    rulePart: " · Regra: {rule}",
  },
  tooltips: {
    syncEnabled:
      "Recalcula e reenvia a disponibilidade e a estadia máxima para a OTA (evita overbooking).",
    syncDisabled: "Conecte a propriedade a um canal para habilitar a sincronização.",
    toggleClosedOpen: "Alternar fechado/aberto",
    managedByPricelabs: "Gerenciado pelo PriceLabs",
    clickToEdit: "Selecione ou clique para editar",
  },
  cellTitle: {
    pastDate: "Data passada",
    closed: "Fechado (clique para abrir)",
    detail:
      "{free} livres · oferecendo {tope} de {total} · {booked} reservados — clique para editar o limite",
  },
  soldBadge: {
    confirmed: "{real} reservas confirmadas",
    withOverbooking: "{real} confirmadas + {over} em overbooking",
  },
  bulkModal: {
    from: "De",
    to: "Até",
    rangeHint:
      "Você pode editar o intervalo aqui para estendê-lo ou ajustá-lo. (A visualização só atualizará o mês atual visualmente.)",
    room: "Quarto",
    whatToEdit: "O que editar",
    optAvail: "Disponibilidade e fechamentos",
    optRate: "Preços e estadia mínima",
    status: "Status",
    open: "Abrir",
    close: "Fechar",
    cap: "limite",
    availHint:
      "Este é o total que você oferece; as reservas são descontadas automaticamente e apenas os quartos livres são vendidos. Máx. {max} (operacional, excluindo manutenção).",
    mainRate: "Tarifa principal",
    mainRateHint:
      "Escolha a tarifa principal a alterar; suas tarifas derivadas se ajustam automaticamente.",
    action: "Ação",
    price: "Preço",
    minStay: "Estadia mínima",
    minStayNights: "Estadia mínima (noites)",
    minStayHelp: "1 = sem restrição (limpar)",
  },
  syncConfirm: {
    title: "Sincronizar com a OTA",
    message:
      "Isso vai recalcular e reenviar a disponibilidade e a estadia máxima deste calendário para a OTA.",
    confirm: "Sim, sincronizar",
  },
  progress: {
    processing: "Processando…",
    syncing: "Sincronizando o calendário com a OTA…",
    updatingAvail: "Atualizando a disponibilidade…",
    updatingRate: "Atualizando a tarifa…",
    applying: "Aplicando as alterações…",
    applyingBulk: "Aplicando a edição em massa…",
    applyingIn: "Aplicando em {name}…",
  },
  toasts: {
    noPropertyToSync: "Não há nenhuma propriedade para sincronizar.",
    syncOk: "Calendário recalculado e sincronizado com a OTA.",
    syncErr: "Não foi possível sincronizar o calendário com a OTA.",
    loadErr: "Não foi possível carregar as informações do hotel.",
    maxAvailClosedBlocked:
      "Máximo disponível: {capacity} (há quartos fechados, bloqueados ou em manutenção).",
    availUpdated: "Disponibilidade atualizada",
    availUpdateErr: "Não foi possível atualizar a disponibilidade",
    freeSuffix: " (livres: {free})",
    rateUpdated: "Tarifa atualizada",
    rateUpdateErr: "Não foi possível atualizar a tarifa",
    maxAvailMaintenance:
      "Máximo disponível: {capacity} (há quartos em manutenção ou fora de operação).",
    noDatesModifiedBooked: "Nenhuma data foi modificada: {count} com reservas.",
    appliedFreeDates:
      "Aplicado às datas livres. {count} data(s) com reservas não foram modificadas.",
    changesApplied: "Alterações aplicadas com sucesso",
    savedNotSyncedYet: "Salvo aqui, mas ainda não chegou aos canais de venda. Será reenviado sozinho em alguns minutos.",
    cannotEditDerivedPricelabs:
      "Você não pode editar uma tarifa derivada ou uma gerenciada pelo PriceLabs.",
    minStayNumberGte1: "A estadia mínima deve ser um número >= 1.",
    invalidAction: "Ação inválida.",
    applyErr: "Não foi possível aplicar as alterações",
    noRoomsToEdit: "Não há quartos para editar.",
    selectAtLeastOneRoom: "Selecione pelo menos um quarto.",
    chooseAction: "Escolha uma ação.",
    selectDateRange: "Selecione um intervalo de datas.",
    enterValidPrice: "Insira um preço válido.",
    minStayGte1: "A estadia mínima deve ser >= 1.",
    appliedWithErrors: "Aplicado a {ok} quarto(s). {failed} com erro",
    noDatesModifiedCapacity:
      "Nenhuma data foi modificada: {count} dia(s) não permitiram esse número de quartos.",
    bulkAppliedClamped:
      "Edição em massa aplicada a {ok} quarto(s). Em {clamped} data(s) foi ajustada ao número de quartos em serviço.",
    bulkApplied: "Edição em massa aplicada a {ok} quarto(s).",
    bulkApplyErr: "Não foi possível aplicar a edição em massa.",
    applyChangesErr: "Não foi possível aplicar as alterações.",
  },
  // Decorative (aria-hidden) empty-state content
  ghost: {
    month: "MAIO 2026",
    day1: "Seg 1",
    day2: "Ter 2",
    day3: "Qua 3",
    day4: "Qui 4",
    day5: "Sex 5",
    day6: "Sáb 6",
    day7: "Dom 7",
    day8: "Seg 8",
    day9: "Ter 9",
    day10: "Qua 10",
    day11: "Qui 11",
    day12: "Sex 12",
    unit1: "Suíte Deluxe",
    unit1Rooms: "(2 quartos)",
    unit2: "Quarto Standard",
    unit2Rooms: "(3 quartos)",
    baseRate: "Tarifa Base",
    nonRefundable: "Não reembolsável",
  },
};
